import { render, staticRenderFns } from "./CharacterDetail.vue?vue&type=template&id=a87fc650&"
import script from "./CharacterDetail.vue?vue&type=script&lang=js&"
export * from "./CharacterDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports